module.exports = __webpack_public_path__ + "static/liva-convert-detail-four-19a2b5a773ac7e81bbfbde77a35866f9.png";